import { useState, useRef, useEffect } from 'react'
import { Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { useAuth } from '../../hooks/use-auth'

type EmailVerifyInputProps = {
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
  onCodeSent?: () => void
}

export function EmailVerifyInput({
  email,
  setEmail,
  onCodeSent,
}: EmailVerifyInputProps) {
  const { authSendCodeMutationAsync } = useAuth()
  const { handleSendCode } = useAuthStore((s) => s.handlers)
  const [count, setCount] = useState(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const onSendSuccess = () => {
    onCodeSent?.()
    setCount(60)
    timerRef.current = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          if (timerRef.current) clearInterval(timerRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  const handleAction = async () => {
    await handleSendCode(email, authSendCodeMutationAsync, onSendSuccess)
  }

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [])

  return (
    <div className='flex flex-col gap-6'>
      <div className='relative'>
        <Mail className='text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2' />
        <Input
          name='email'
          className='bg-muted focus-visible:ring-primary h-12 border-none pl-10 focus-visible:ring-1'
          placeholder='请输入您的邮箱地址'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <Button
        className='h-12 w-full text-base font-medium transition-all active:scale-[0.98]'
        variant={count > 0 ? 'outline' : 'default'}
        disabled={count > 0 || !email}
        onClick={handleAction}
      >
        {count > 0 ? `${count}s` : '继续'}
      </Button>
    </div>
  )
}
